var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shot",style:(_vm.position),on:{"click":function($event){$event.preventDefault();return _vm.changeActiveShot.apply(null, arguments)}}},[_c('a',{class:{ active: _vm.activeShotIndex == _vm.index },attrs:{"href":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }